import { Nullable } from '@orcar/common';
import {
  isMobileAtom,
  ListStyle,
  MustRead,
  useGetCompanyInfo,
  useRecoil,
} from '@orcar/common-d2c';
import { useRef } from 'react';
import styled from 'styled-components';
import CancellationFee from '@/components/reservationDetails/CancellationFee';
import { CompanyInfo } from '@/components/reservationDetails/CompanyInfo';
import RentPolicy from '@/components/reservationDetails/RentPolicy';

// 모든 차량에 공통으로 적용되는 필독 사항. (기존 차량 상세 페이지에서 노출되던
// 내용을 헤더 메뉴로 옮겨, 예약 흐름과 무관하게 언제든 확인할 수 있게 한다.)
const MUST_READ_POLICIES = [
  '고객님께 보다 깨끗하고 쾌적한 차량을 제공하고자 전 차량 금연차량임을 고지드립니다.',
  '흡연 및 악취 발생 시 크리닝 비용 기본 20~30만원 발생합니다.',
  '고객님께 보다 깨끗하고 쾌적한 차량을 제공하고자 전 차량 낚시용품은 이용 불가임을 고지드립니다.',
  '무단으로 이용 시 비용 기본 20~30만원 발생합니다.',
];

const MustReadPage = () => {
  const { recoilValue: isMobile } = useRecoil(isMobileAtom);
  const { data: companyData } = useGetCompanyInfo();

  // MustRead 컴포넌트는 tabRef를 필수로 참조하므로 로컬 ref를 넘겨준다.
  const tabRef = useRef<Nullable<HTMLDivElement>[]>([]);

  return (
    <LayoutWrapper isMobile={isMobile}>
      <PageTitle isMobile={isMobile}>필독사항</PageTitle>
      <WhiteBgWrapper isMobile={isMobile}>
        <MustRead
          tabRef={tabRef}
          isMobile={isMobile}
          rentPolicies={MUST_READ_POLICIES}
        />
        <CancellationFee padding='30px 0' />
      </WhiteBgWrapper>
      <WhiteBgWrapper isMobile={isMobile}>
        <CompanyInfo company={companyData} isMobile={isMobile} hasPadding />
        <RentPolicy
          name={companyData?.name || ''}
          rentPolicies={companyData?.rentalRules || ''}
          isMobile={isMobile}
          hasPadding
        />
      </WhiteBgWrapper>
    </LayoutWrapper>
  );
};

export default MustReadPage;

const LayoutWrapper = styled.div<{ isMobile: boolean }>`
  display: flex;
  flex-direction: column;
  width: ${({ isMobile }) => (isMobile ? '100%' : '792px')};
  ${({ isMobile }) => isMobile && 'padding: 40px 0 40px'};
`;

const PageTitle = styled.h1<{ isMobile: boolean }>`
  margin-bottom: 20px;
  padding: ${({ isMobile }) => (isMobile ? '0 20px' : '0')};
  ${({ isMobile, theme }) => (isMobile ? theme.NEW_FONT.H4 : theme.NEW_FONT.H3)};
`;

const WhiteBgWrapper = styled.div<{ isMobile: boolean }>`
  width: 100%;
  gap: 30px;
  padding: 0 28px;
  margin-bottom: ${({ isMobile }) => (isMobile ? '10px' : '24px')};
  background-color: ${({ theme }) => theme.COLOR.WHITE};
  border-radius: ${({ theme }) => theme.BORDER_RADIUS.LEVEL_02};

  & > *:not(:last-child) {
    border-bottom: 1px solid ${({ theme }) => theme.COLOR.GREY_05};
  }

  & li {
    ${ListStyle}
  }
`;
